module.exports = __webpack_public_path__ + "static/media/banner_mobil_2.aa928735.png";